<template>
  <div class="alert-wrapper">
    <div
      v-for="alert in alerts"
      :key="alert.id"
      :class="alert.type"
      role="alert"
    >
      {{ alert.message }}
      <button
        type="button"
        class="close"
        aria-label="Schließen"
        @click="remove(alert)"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</template>

<script>

const data = {
  'show': true
}

export default {
  data () {
    return data
  },
  computed: {
    alerts: function () {
      return this.$store.getters.alertList
    }
  },
  methods: {
    remove (alert) {
      this.$store.dispatch('removeAlert', {'id': alert.id})
    }
  }
}
</script>

<style lang="scss" scoped>
  .alert-wrapper {
    width: 98%;

    div {
      margin-top: 10px;
    }
  }
</style>
